import { render, staticRenderFns } from "./ProcedureItemRow.vue?vue&type=template&id=dd4cdb50&scoped=true&"
import script from "./ProcedureItemRow.vue?vue&type=script&lang=ts&"
export * from "./ProcedureItemRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4cdb50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCombobox,VIcon,VTextField})
